import React from 'react';
import styled from 'styled-components/macro';
import { Tooltip } from '@material-ui/core';
import Colors from '../../Colors';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import FlareIcon from '@material-ui/icons/Flare';
import ClearIcon from '@material-ui/icons/Clear';
import Button from '../../../components/Button';
import Animation from '../../../components/Animation';
import { SimpleFlexContainer } from '../../../components/layouts/ng-layouts/Containers';

const StyledAnimation = styled(Animation)`
  position: fixed;
  bottom: 145px;
  left: 0;
  right: 0;
  z-index: 99;
`;

const ControlsContainer = styled.div`
  border-radius: 12px;
  color: #fff;
`;

const ControlsBox = styled.div`
  font-size: 12px;
  background-color: ${Colors.PRIMARY};
  border-radius: 12px;
  box-shadow: 0px 10px 20px 0px #4c84ff66;
  margin: auto;
  padding: 0 1rem;
  text-align: center;
  width: fit-content;
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
`;

const SelectedLabel = styled.span`
  position: relative;
  top: 1px;
  vertical-align: middle;
  background: #355cb2;
  padding: 0.5rem;
  border-radius: 12px;
  margin: 0.5rem 0;
  display: inline-block;
`;

const StyledLabel = styled.span`
  font-size: 12px !important;
`;

const ControlLink = styled.span`
  color: #fff;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  margin: 0.5rem;
  svg {
    vertical-align: middle;
  }
`;

const DismissButton = styled(Button)`
  background-color: #fff !important;
  box-shadow: none !important;
  color: ${Colors.PRIMARY} !important;
  font-size: 12px !important;
  margin-left: 2rem !important;
`;

const Positioner = styled(SimpleFlexContainer)`
  z-index: 1000;
  position: fixed;
  bottom: 0;
  width: 100vw;
  left: 0;
  padding: 4rem 0;
  background: linear-gradient(180deg, #355cb200, #355cb233);

  transition: 0.4s;
  visibility: ${({ $in }) => ($in ? 'visible' : 'hidden')};
  opacity: ${({ $in }) => ($in ? 1 : 0)};
`;

const FormBuilderMultiControlsView = props => {
  return (
    <>
      <StyledAnimation in={props.visible}>
        <ControlsContainer>
          <ControlsBox>
            <SelectedLabel>{props.selectedCount + ' '} selected</SelectedLabel>
            <ControlLink onClick={props.onRequiredToggled}>
              <StyledLabel data-testid={`multi-required`}>
                <FlareIcon />
                &nbsp;{' '}
                {props.currentRequired
                  ? 'Set as not required'
                  : 'Set as required'}
              </StyledLabel>
            </ControlLink>

            <Tooltip
              title={
                props.canChangeAllToAdmin
                  ? ''
                  : 'Selected fields cannot be changed to/from admin-only'
              }
            >
              <span>
                <ControlLink
                  onClick={() => {
                    if (props.canChangeAllToAdmin) {
                      props.onAdminOnlyToggled();
                    }
                  }}
                  disabled={!props.canChangeAllToAdmin}
                >
                  <StyledLabel data-testid={`multi-admin-only`}>
                    <PeopleAltIcon />
                    &nbsp;{' '}
                    {props.currentAdminOnly
                      ? 'Show for all users'
                      : 'Set as admin only'}
                  </StyledLabel>
                </ControlLink>
              </span>
            </Tooltip>
            <DismissButton endIcon={<ClearIcon />} onClick={props.dismiss}>
              Dismiss
            </DismissButton>
          </ControlsBox>
        </ControlsContainer>
      </StyledAnimation>
      <Positioner $in={props.visible} />
    </>
  );
};

export default FormBuilderMultiControlsView;
